export const phoneNumberFormat = (phoneNumber: string) => {
  return phoneNumber.replace(/[\s\-()]/g, '');
};

export const phoneNumberFormatForInput = (phoneNumber: string) => {
  const cleaned = phoneNumber.replace(/[^\d+]/g, '');
  if (!cleaned) {
    return '';
  }

  let digits = cleaned;

  if (digits.startsWith('+7')) {
    digits = digits.slice(2);
  } else if (digits.startsWith('7') && digits.length === 11) {
    digits = digits.slice(1);
  } else if (digits.startsWith('8') && digits.length === 11) {
    digits = digits.slice(1);
  } else if (digits.startsWith('+8') && digits.length === 12) {
    digits = digits.slice(2);
  }

  digits = digits.replace(/\D/g, '');
  if (digits.length > 10) {
    digits = digits.slice(-10);
  }

  const part1 = digits.slice(0, 3);
  const part2 = digits.slice(3, 6);
  const part3 = digits.slice(6, 8);
  const part4 = digits.slice(8, 10);

  let result = '+7';
  if (part1.length) {
    result += ` ${part1}`;
  }
  if (part2.length) {
    result += `-${part2}`;
  }
  if (part3.length) {
    result += `-${part3}`;
  }
  if (part4.length) {
    result += `-${part4}`;
  }

  return result;
};
